'use strict';
const { gql } = require('graphql-tag');
const moment = require('moment');
var { fragments } = require('../fragments');
const configDefaults = require('../configs/default');
const { getDistance } = require('geolib');

var _parent = {};

var customers = {
  init: p => (_parent = p),

  ////////////////////////////////////////////////////////////////////////////////
  // CONFIG CODE IN HERE IS DEPRECATED. DO NOT USE FOR NEW DEVELOPMENT.         //
  ////////////////////////////////////////////////////////////////////////////////

  // vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv //

  /** Fetch config object from SAT database
   * @param {Int} customerId - internal customer id
   * @return {Object} return config JSONB object from database
   */
  getConfig: async function (customerId) {
    //validate input
    if (!customerId) {
      throw new Error('no customerId entered');
    }
    if (typeof customerId !== 'number') {
      throw new Error('customerId must be an integer');
    }
    //query customer's config by id
    try {
      let res = await _parent.gql.query(
        gql`
          query getCustomerbyId($id: bigint!) {
            customers(where: { id: { _eq: $id } }) {
              id
              config
            }
          }
        `,
        { id: customerId }
      );

      if (!res) throw new Error(`No response from getCustomerbyId`);

      // validate response is an array and length > 0
      const { success = false, data = [] } = res;
      if (!success && Array.isArray(data) && data.length === 0)
        throw new Error(`No customer found with id ${customerId}`);

      //response will be standardized object created by handler
      return Object.assign(configDefaults, data[0].config);
    } catch (err) {
      throw err;
    }
  },

  /** Update customer config object
   * @param {BigInt} customerId - internal customer id
   * @param {Object} configObj - config jsonb object to update with
   * @return {Object} return config JSONB object
   */
  updateConfig: async function (customerId, configObj) {
    if (!customerId) throw new Error('No customerId entered');
    if (typeof customerId !== 'number') throw new Error('customerId must be an integer');
    if (typeof configObj !== 'object' && configObj !== null) throw new Error('configObj must be an object');

    try {
      let res = await _parent.gql.mutation(
        gql`
          mutation sdk_customers_update_config($id: bigint!, $config: jsonb) {
            update_customers(where: { id: { _eq: $id } }, _set: { config: $config }) {
              affected_rows
              returning {
                id
                config
              }
            }
          }
        `,
        { id: customerId, config: configObj }
      );
      return _parent.gql.injectAffectedRowsAtRoot(res);
    } catch (err) {
      throw err;
    }
  },

  /** Fetch colors from branding config object via SAT database
   * @param {Int} customerId - internal customer id
   *  @return {Object} return branding config JSONB object via database
   */
  getBrand: async function (customerId) {
    if (!customerId) {
      throw new Error('no customerId entered');
    }
    if (typeof customerId !== 'number') {
      throw new Error('customerId must be an integer');
    }

    try {
      let res = await _parent.gql.query(
        gql`
          query sdk_customers_get_Brand($id: bigint!) {
            customers(where: { id: { _eq: $id } }) {
              branding: config(path: "$branding")
            }
          }
        `,
        { id: customerId }
      );

      if (res.success === true) {
        console.log('res', res);
        let customers = res.data;
        if (customers.length === 0) {
          throw new Error(`No customer found with id ${customerId}`);
        } else if (!customers[0].branding) {
          throw new Error(
            `Customer ${customerId} has no branding config field. This must be created before setting brand customizations.`
          );
        } else {
          return customers[0].branding;
        }
      }
    } catch (err) {
      throw err;
    }
  },

  /** Fetch name from branding config object via SAT database
   * @param {Int} customerId - internal customer id
   * @return {Object} return config JSONB object from database
   */
  getBrandedName: async function (customerId) {
    if (!customerId) {
      throw new Error('no customerId entered');
    }
    if (typeof customerId !== 'number') {
      throw new Error('customerId must be an integer');
    }

    try {
      let res = await _parent.gql.query(
        gql`
          query sdk_customers_get_brandName($id: bigint!) {
            customers(where: { id: { _eq: $id } }) {
              brand_name: config(path: "$branding.name")
            }
          }
        `,
        { id: customerId }
      );

      if (res.success === true) {
        let customers = res.data;
        if (customers.length === 0) {
          throw new Error(`No customer found with id ${customerId}`);
        } else if (customers[0]) {
          return customers[0].brand_name;
        } else {
          return null;
        }
      }
    } catch (err) {
      throw err;
    }
  },

  /** Fetch appraisals subscription from customer config object
   * @param {BigInt} customerId - internal customer id
   * @return {Object} return appraisals config JSONB object
   */
  getAppraisalsConfig: async function (customerId) {
    if (!customerId) throw new Error('No customerId entered');
    if (typeof customerId !== 'number') throw new Error('customerId must be an integer');

    try {
      let res = await _parent.gql.query(
        gql`
          query sdk_customers_get_appraisals_config($id: bigint!) {
            customers(where: { id: { _eq: $id } }) {
              appraisals: config(path: "$appraisals")
            }
          }
        `,
        { id: customerId }
      );

      if (res.success === true) {
        let customers = res.data;
        if (customers.length === 0) throw new Error(`No customer found with id ${customerId}`);
        else if (!customers[0].appraisals) throw new Error(`Customer #${customerId} has no appraisals config field.`);
        else return customers[0].appraisals;
      }
    } catch (err) {
      throw err;
    }
  },

  /** Build appraisals subscription object to update config with
   * @param {Boolean} active - Is the subscription currently active
   * @param {Array} activeTimestamps - Stores the time periods the subscription was active
   * @param {Array} allowedMoveTypes - Types of moves allowed for the customer to view (we currently only have 'concierge' and 'operations')
   * @return {Object} return appraisals config JSONB object that was built
   */
  buildAppraisalsConfig: async function (active = null, activeTimestamps = null, allowedMoveTypes = null) {
    try {
      let appraisalsConfig = {};
      let now = moment.utc(moment().format());

      appraisalsConfig.active = active ? true : false;

      if (activeTimestamps && Array.isArray(activeTimestamps)) appraisalsConfig.active_timestamps = activeTimestamps;
      else
        appraisalsConfig.active_timestamps = [
          {
            from: now,
            to: `now`,
          },
        ];

      if (allowedMoveTypes && Array.isArray(allowedMoveTypes)) appraisalsConfig.allowed_move_types = allowedMoveTypes;
      else appraisalsConfig.allowed_move_types = [`concierge`];

      return appraisalsConfig;
    } catch (err) {
      throw err;
    }
  },

  // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ //

  ////////////////////////////////////////////////////////////////////////////////
  // CONFIG CODE IN HERE IS DEPRECATED. DO NOT USE FOR NEW DEVELOPMENT.         //
  ////////////////////////////////////////////////////////////////////////////////

  /** Determine the organization's nearest rooftop to a vehicle location
   * @param {Bigint} customerId - customer id from which to get the associated org and its customers
   * @param {Array} pickupCoords - latitude and longitude coordinates of the pickup location
   * @return {Bigint} returns the id of the nearest rooftop
   */
  getNearestRooftop: async (customerId = null, pickupCoords = {}) => {
    if (!customerId) throw new Error('Missing Customer ID');
    if (!pickupCoords || !pickupCoords.latitude || !pickupCoords.longitude)
      throw new Error('Missing Pickup Coordinates');

    const orgRes = await _parent.gql.query(
      gql`
        query getOrganizationRooftopsFromCustomerId($customerId: bigint!) {
          customers(where: { id: { _eq: $customerId } }) {
            id
            organization {
              customers {
                id
                name
                address
                location {
                  latitude
                  longitude
                }
              }
            }
          }
        }
      `,
      { customerId: customerId }
    );
    if (!orgRes || !orgRes.success || !orgRes.data || !orgRes.data.length)
      throw new Error('Failed to fetch organization rooftops');
    const orgResData = orgRes.data[0] || [];

    const organization = orgResData.organization || {};
    const rooftops = organization.customers || [];

    const updatedRooftops = await Promise.all(
      rooftops.map(async rooftop => {
        let distance = null;
        if (rooftop.location && rooftop.location.latitude && rooftop.location.longitude) {
          console.log('rooftop coordinates', rooftop.location.latitude, rooftop.location.longitude);
          distance = getDistance(
            { latitude: pickupCoords.latitude, longitude: pickupCoords.longitude },
            { latitude: rooftop.location.latitude, longitude: rooftop.location.longitude }
          );
          console.log('distance info', distance);
        }

        // Add the distance response as a new property to the rooftop object
        return {
          ...rooftop,
          distance: distance,
        };
      })
    );

    const shortestDistance = updatedRooftops.reduce((prev, current) => {
      return parseInt(current.distance) < parseInt(prev.distance) ? current : prev;
    });

    // check if shortest distance is less than 100 miles (161000 meters)
    if (shortestDistance.distance < 161000) {
      return shortestDistance.id;
    } else {
      return {
        statusCode: 404,
        body: 'No rooftop found within 100 miles',
      };
    }
  },

  /** Fetch other customers in organization by customer id
   * @param {number} orgId - organization id
   * @return {Array} array of customer objects in the same organization
   */
  getCustomersInOrg: async orgId => {
    if (!orgId) throw new Error('Missing Org ID');
    const GET_ORG_CUSTOMERS = gql`
      query getOrgCustomers($orgId: bigint!) {
        customers(where: { organization_id: { _eq: $orgId } }) {
          id
        }
      }
    `;

    const orgCustomersRes = await _parent.gql.query(GET_ORG_CUSTOMERS, { orgId: orgId });
    if (orgCustomersRes && orgCustomersRes.data && orgCustomersRes.data.length) {
      return orgCustomersRes.data;
    }
    return [];
  },
};

module.exports = customers;
